import React, {useEffect} from 'react';
import UploadModern from '../components/UploadModern';
import Box from '@mui/material/Box';
import AppList from '../../../../../../@crema/core/AppList';
import {useDropzone} from 'react-dropzone';
import PropsType from 'prop-types';
import FileRow from '../components/FileRow';

const Basic = ({setFiles, files}) => {
  const dropzone = useDropzone();

  useEffect(() => {
    setFiles(dropzone.acceptedFiles);
  }, [dropzone.acceptedFiles]);

  const onDeleteUploadFile = (file) => {
    dropzone.acceptedFiles.splice(dropzone.acceptedFiles.indexOf(file), 1);
    setFiles([...dropzone.acceptedFiles]);
  };

  return (
    <Box sx={{position: 'relative'}}>
      <UploadModern
        uploadText='Drag n drop some files here, or click to select files'
        dropzone={dropzone}
      />
      {files && files.length > 0 && (
        <aside>
          <AppList
            data={files}
            renderRow={(file, index) => (
              <FileRow
                key={index + file.path}
                file={file}
                onDeleteUploadFile={onDeleteUploadFile}
              />
            )}
          />
        </aside>
      )}
    </Box>
  );
};

Basic.propTypes = {
  setFiles: PropsType.func,
  files: PropsType.array,
};

export default Basic;
